import Rellax from 'rellax';

class Parallax {

    /**
     * @since 0.14.0
     * @method constructor
     */
    constructor() {
        // Declare and initialize
        this.selector = '.meetings-parallax';

        // Run initialization
        this.init()
    }

    /**
     * Initialize the class.
     *
     * @method init
     * @since 0.14.0
     * @returns object The initialized map
     */
    init() {

        // Rellax
        if (!$(this.selector).length)
            return;

        // Initialize the parallax
        var rellax = new Rellax(this.selector, {
            speed:      -5,
            center:     false,
            wrapper:    null,
            round:      true,
            vertical:   true,
            horizontal: false,
        });

    }
}

export default Parallax;